import React from 'react';
import {
  Category,
  CategoryCarousel,
  CategoryCarouselProps,
  Control,
} from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './CategoryCarouselBlock.style';

export const CategoryCarouselBlock = (props: CategoryCarouselProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
    <CategoryCarousel {...props} />
  </BlockContainer>
);

export type { CategoryCarouselProps, Control, Category };
